import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import {
  AuthenticationResult,
  BrowserCacheLocation,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser'
import { AtomModule } from '../../atom/atom.module'
import { environment } from '../../environments/environment'
import { AppService } from '../../service/app.service'

@Component({
  selector: 'app-microsoft-signin',
  templateUrl: './microsoft-signin.component.html',
  styleUrl: './microsoft-signin.component.less',
  standalone: true,
  imports: [AtomModule],
})
export class MicrosoftSigninComponent implements OnInit {
  @Output() registerClick: EventEmitter<void> = new EventEmitter()
  @Output() token: EventEmitter<string> = new EventEmitter()
  @Output() buttonClick: EventEmitter<void> = new EventEmitter()

  @Input() pluginName = ''
  @Input() text = ''

  msalInstance: PublicClientApplication

  isBrowser: boolean

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.appService.isBrowser$.subscribe((state) => {
      this.isBrowser = state
    })
  }

  loggerCallback(logLevel: LogLevel, message: string) {
    console.log(message)
  }

  async login() {
    try {
      this.buttonClick.emit()
      console.log('xbox login')

      // docs: https://learn.microsoft.com/en-us/entra/identity-platform/quickstart-single-page-app-angular-sign-in
      this.msalInstance = new PublicClientApplication({
        auth: {
          clientId: environment.MICROSOFT_CLIENT_ID,
          // as for tenantId, I used `common` instead of real tenant id, I followed the docs: https://learn.microsoft.com/en-us/azure/bot-service/bot-builder-authentication?view=azure-bot-service-4.0&tabs=userassigned%2Caadv2%2Cjavascript#register-your-azure-ad-application-with-your-bot
          authority: 'https://login.microsoftonline.com/common',
          redirectUri: window.location.origin,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          // set to true for IE 11
          storeAuthStateInCookie:
            window.navigator.userAgent.indexOf('MSIE ') > -1 ||
            window.navigator.userAgent.indexOf('Trident/') > -1,
        },
        system: {
          loggerOptions: {
            loggerCallback: this.loggerCallback,
            logLevel: LogLevel.Info,
            piiLoggingEnabled: false,
          },
        },
      })
      await this.msalInstance.initialize()
      const response: AuthenticationResult = await this.msalInstance.loginPopup(
        {
          scopes: ['User.Read'],
        }
      )

      // docs: https://learn.microsoft.com/en-us/entra/identity-platform/scenario-spa-acquire-token?tabs=javascript2
      this.msalInstance
        .acquireTokenSilent({
          account: response.account,
          scopes: ['User.Read'],
        })
        .then((response) => {
          this.token.emit(response.accessToken)
        })
    } catch (error) {
      console.error('Microsoft login failed:', error)
    }
  }
}
